import React from "react";
import propTypes from "prop-types";

import RatingIcon from "../RatingIcon";

const RATING_OPTIONS = [1, 2, 3, 4, 5];

const RatingIcons = ({ listingId, listingType, rating, updateRating }) => (
  <>
    {RATING_OPTIONS.map(r => (
      <RatingIcon
        key={`rating-icon-${r}`}
        marked={rating === r}
        name={`tour-rating-for-${listingType}-${listingId}`}
        ratingIconId={`rating-icon-${listingId}-${listingType}-${r}`}
        updateRating={updateRating}
        value={r}
      />
    ))}
  </>
);

RatingIcons.propTypes = {
  listingId: propTypes.number.isRequired,
  listingType: propTypes.string.isRequired,
  rating: propTypes.number,
  updateRating: propTypes.func.isRequired
};

RatingIcons.defaultProps = {
  rating: null
};

export default RatingIcons;
